import React from "react";
import { Navigate } from "react-router-dom";
import Settings from "components/Settings";
import KpiTabView from "./components/KpiTabView";

const prebuiltComponents = {
  IntegrationSection: ({ tabId }) => <Navigate to={`/settings?selectedTab=${tabId}`} />,
  HubSettings: ({ tabId }) => <Navigate to={`/settings?selectedTab=${tabId}`} />,
  CompanyAdminSettings: ({ tabId }) => <Navigate to={`/settings?selectedTab=${tabId}`} />,
  TeamsSettings: ({ tabId }) => <Navigate to={`/settings?selectedTab=${tabId}`} />,
  KpisSettings: KpiTabView,
};

const Kpi = () => <Settings prebuiltComponents={prebuiltComponents} />;

export default Kpi;
